<template>
	<Button
		@click="onClick"
		type="primary"
		:size="size"
		:disabled="disabled"
		v-tooltip=" _traducao('global', 'adicionar') "
	>
		<template #icon>
			<IconPlus :size="size" />
		</template>
		<slot />
	</Button>
</template>

<script>
import Button from './Button.vue'
import IconPlus from '../icon/IconPlus.vue'
import ButtonMixin from './ButtonMixin.js'
export default {
	mixins: [ButtonMixin],
	components: {
		Button,
		IconPlus
	}
}
</script>
